import {
  DvIconCellRenderer,
  DvIconCellRendererParams,
  DvToolbarAction,
} from '@devinco/ui/grid';
import { Injectable, inject } from '@angular/core';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { getStandardActionPreset } from '@features/vt-grid/presets/preset-actions';
import { TranslateService } from '@ngx-translate/core';
import { FleetDto } from '@pages/fleet/interfaces';
import { ColDef } from 'ag-grid-community';

@Injectable()
export class FleetGridService {
  private translate = inject(TranslateService);

  readonly colDefs: ColDef<FleetDto>[] = [
    {
      headerName: 'Grid.Id',
      field: 'FleetID',
      type: [ColumnType.Id],
      enableRowGroup: false,
      hide: true,
    },
    {
      field: 'AssetID',
      cellRenderer: DvIconCellRenderer,
      cellRendererParams: (params: {
        data?: FleetDto;
      }): DvIconCellRendererParams => ({
        icon: params.data?.VehicleID ? 'car' : 'viatracks_find',
      }),
      headerName: 'FleetGrid.ItemType',
      headerClass: 'text-center',
      enableRowGroup: true,
      valueGetter: () => 1,
      filterValueGetter: (params: { data?: FleetDto }) => {
        return params.data?.VehicleID ? 'vehicle' : 'asset';
      },
      filterParams: {
        values: ['vehicle', 'asset'],
        valueFormatter: (data: { value: 'vehicle' | 'asset' }) => {
          const key =
            data.value === 'vehicle'
              ? 'FleetGrid.IsVehicle'
              : 'FleetGrid.IsAsset';
          return this.translate.instant(key);
        },
      },
      sortable: true,
      filter: 'agSetColumnFilter',
      pinned: 'left',
    },
    {
      field: 'Description',
      headerName: 'FleetGrid.Description',
      type: [ColumnType.Text],
      pinned: 'left',
    },
    {
      field: 'RegistrationNumber',
      headerName: 'FleetGrid.RegistrationNumber',
      type: [ColumnType.Text],
    },
    {
      field: 'DepartmentDescription',
      headerName: 'FleetGrid.DepartmentDescription',
      type: [ColumnType.Text],
    },
    {
      field: 'TemporaryGeolocation',
      headerName: 'FleetGrid.TemporaryGeolocation',
      type: [ColumnType.Checkbox],
    },
    {
      field: 'PermanentGeolocation',
      headerName: 'FleetGrid.PermanentGeolocation',
      type: [ColumnType.Checkbox],
    },
    {
      field: 'VehicleTag',
      headerName: 'FleetGrid.VehicleTag',
      type: [ColumnType.Text],
    },
    // BELOW hidden columns that are used only for data
    { field: 'LastGPSLat', type: ColumnType.Hidden },
    { field: 'LastGPSLon', type: ColumnType.Hidden },
    { field: 'LastActivityTime', type: ColumnType.Hidden },
    { field: 'LastCourse', type: ColumnType.Hidden },
    { field: 'Username', type: ColumnType.Hidden },
    { field: 'UserDescription', type: ColumnType.Hidden },
    { field: 'Mobile', type: ColumnType.Hidden },
    { field: 'CurrentLocation', type: ColumnType.Hidden },
    { field: 'Serial', type: ColumnType.Hidden },
    { field: 'DocumentThumbnail', type: ColumnType.Hidden },
    { field: 'Temperature', type: ColumnType.Hidden },
    { field: 'LastMoved', type: ColumnType.Hidden },
    { field: 'VehicleID', type: ColumnType.Hidden },
    {
      field: 'TemporaryFleetLocationID',
      type: ColumnType.Hidden,
    },
    { field: 'Comment', type: ColumnType.Text },
  ];

  getGridActions = (): DvToolbarAction[] => getStandardActionPreset();
}
